export const KM_OFFER_TEST_IDS = {
    OFFER_WRAPPER: "offer-wrapper",
    ASK_FOR_OFFER: "ask-for-offer-button",
    OFFER_DETAILS: "offer-details-button",
    DETAILS_ASK_FOR_OFFER: "details-ask-for-offer-button",
    DETAILS_ASK_FOR_OFFER_MOBILE: "details-ask-for-offer-button-mobile",
    SHOW_PHONE_NUM: "show-phone-num-button",
    LIKE_BUTTON: "like-button",
    DISLIKE_BUTTON: "dislike-button",
    EXPANDABLE_SECTION: "expandable-section-button",
    RESTORE_BUTTON: "restore-button",
    DISMISS_BUTTON: "dismiss-button",
    CONFIRM_SEND_LEAD: "confirm-send-lead-button",
    AFTER_LIKE_MODAL: "after-like-modal",
    AFTER_DISLIKE_MODAL: "after-dislike-modal"
};
export const KM_OFFER_TEST_IDS = {
    OFFER_WRAPPER: "offer-wrapper",
    ASK_FOR_OFFER: "ask-for-offer-button",
    OFFER_DETAILS: "offer-details-button",
    DETAILS_ASK_FOR_OFFER: "details-ask-for-offer-button",
    DETAILS_ASK_FOR_OFFER_MOBILE: "details-ask-for-offer-button-mobile",
    SHOW_PHONE_NUM: "show-phone-num-button",
    LIKE_BUTTON: "like-button",
    DISLIKE_BUTTON: "dislike-button",
    EXPANDABLE_SECTION: "expandable-section-button",
    RESTORE_BUTTON: "restore-button",
    DISMISS_BUTTON: "dismiss-button",
    CONFIRM_SEND_LEAD: "confirm-send-lead-button",
    AFTER_LIKE_MODAL: "after-like-modal",
    AFTER_DISLIKE_MODAL: "after-dislike-modal"
};
